export function applyDocumentTitle(title: string): void {
  if (typeof document === "undefined") {
    return;
  }

  const isContainerTestEnvironment = document.documentElement.dataset.environment === "ContainerTest";
  const documentTitlePrefix = isContainerTestEnvironment ? "[TEST] " : "";
  document.title = `${documentTitlePrefix}${title}`;
}
